import { useDispatch } from "react-redux";
import { filterActions } from "../../store/filter";
import { workqueueActions } from "../../store/workqueue";
import Button from "../common/Button";

import classes from './DashboardButtons.module.css'
import { Link, useNavigate } from "react-router-dom";

export default function DashboardButtons({caseId, workqSlug, workq}) {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    function goToWorkQ() {
        navigate(`/work-queues/${workqSlug}`)
        dispatch(filterActions.setCurrentPage(1))
        dispatch(workqueueActions.setSelectedWorkQueue(workq))
        
    }

    return <div className={classes.container}>
        {caseId && workqSlug && <Link to={`/work-queues/${workqSlug}/${caseId}`}>View case <i className="ti ti-arrow-up-right"></i></Link>}
        {/* {workqSlug && <Link to={`/work-queues/${workqSlug}`}>View all <i className="ti ti-arrow-up-right"></i></Link>} */}

        {workqSlug && <button to={`/work-queues/${workqSlug}`} onClick={goToWorkQ} >
            View all <i className="ti ti-arrow-up-right"></i>
        </button>}  
    </div>
}